module.exports = __webpack_public_path__ + "img/game_main_pc_231_off.32e91765.png";